export default "__VITE_ASSET__BHhIJYkB__"